import React, { useEffect } from 'react';
import { SpinnerGap, CheckCircle } from 'phosphor-react';

interface ToastProps {
  isVisible: boolean;
  isLoading: boolean;
  progress: number;
  message: string;
  onDismiss: () => void;
}

const Toast: React.FC<ToastProps> = ({ isVisible, isLoading, progress, message, onDismiss }) => {
  useEffect(() => {
    if (!isLoading && isVisible) {
      const timer = setTimeout(() => {
        onDismiss();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isLoading, isVisible, onDismiss]);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-1/2 md:left-auto md:right-4 transform md:transform-none -translate-x-1/2 z-[9999]">
      <div className="bg-white dark:bg-zinc-800 rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 p-4 w-72">
        <div className="flex items-center">
          <div className="flex-1">
            <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{message}</p>
            {isLoading && (
              <>
                <div className="mt-1 w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1.5">
                  <div 
                    className="bg-blue-500 h-1.5 rounded-full transition-all duration-300 ease-in-out"
                    style={{ width: `${progress}%` }}
                  />
                </div>
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">Takes around 1 min</p>
              </>
            )}
          </div>
          <div className="ml-4 flex-shrink-0">
            {isLoading ? (
              <SpinnerGap className="h-5 w-5 text-blue-500 animate-spin" weight="regular" />
            ) : (
              <CheckCircle className="h-5 w-5 text-green-500" weight="fill" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Toast; 